<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M14 12h2V9h-2zm-9.5 8L4 18h1.5q.2 0 .35-.15T6 17.5v-3.125l-.825.338q-.4.163-.775.287L4 13.05q.475-.1.988-.275T6 12.4V9H4.5V7H6V4h2v3h1.5v2H8v2.4q.375-.225.725-.45t.675-.45v2q-.3.25-.65.488t-.75.437V18.5q0 .575-.462 1.038T6.5 20zm5.55 0l-1.1-1.65q1.05-.7 1.813-1.875T11.825 14H10v-2h2V9h-1.5V7h9v2H18v3h2v2h-2v6h-2v-6h-2.15q-.35 1.775-1.362 3.413T10.05 20m7.2-12.25L15.525 7q.4-.675.888-1.475T17.2 4l1.85.675q-.375.725-.875 1.55T17.25 7.75m-4.725-.2q-.425-.625-.975-1.375T10.5 4.85L12.3 4q.45.575.963 1.3t.937 1.325z"
    />
  </svg>
</template>
